import { encodePaginatableQuery, encodeSortableQuery, PaginatableQuery, Query, SortableQuery } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface CategoryQuery extends PaginatableQuery, SortableQuery {
  search: string;
}

export const encodeCategoryQuery = (query: CategoryQuery): Query => ({
  ...encodePaginatableQuery(query),
  ...encodeSortableQuery(query),
  search: q.string(query.search),
});
